import { render, staticRenderFns } from "./D201.vue?vue&type=template&id=1949cb43&scoped=true"
import script from "./D201.vue?vue&type=script&lang=js"
export * from "./D201.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=1949cb43&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1949cb43",
  null
  
)

export default component.exports